export default __webpack_public_path__ + "static/media/FoodChainCity_11.bae3cbf4.png";